const formatPrice = (
  price: number,
  currency: string,
  locale: string,
) => Intl.NumberFormat(
  locale, {
    style: 'currency',
    currency,
  },
).format(price);

export default formatPrice;
